import { createSlice } from "@reduxjs/toolkit";

export const ArtistScreenSlice = createSlice({
  name: "ArtistScreenReducer",
  initialState: {
    artistStepOne: JSON.parse(localStorage.getItem("stepOne")) ?? null,
    artistStepTwo: JSON.parse(localStorage.getItem("stepTwo")) ?? null,
    artistStepThree: JSON.parse(localStorage.getItem("stepThree")) ?? null,
    artistStepFour: JSON.parse(localStorage.getItem("stepFour")) ?? null,
    recruiterStepOne:
      JSON.parse(localStorage.getItem("recruiterStepOne")) ?? null,
    artistStepFive: JSON.parse(localStorage.getItem("stepFive")) ?? null,
    recruiterStepTwo:
      JSON.parse(localStorage.getItem("recruiterStepTwo")) ?? null,
    agencyStepOne: JSON.parse(localStorage.getItem("agencyStepOne")) ?? null,
    profilePic: JSON.parse(localStorage.getItem("profilePic")) ?? null,
    agencyLogo: JSON.parse(localStorage.getItem("agencyLogo")) ?? null,
    agencyLogoSignedUrl:
      JSON.parse(localStorage.getItem("agencyLogoSignedUrl")) ?? null,
      agencyStepTwo:JSON.parse(localStorage.getItem("agencyStepTwo")) ?? null,
      agencyStepThree:JSON.parse(localStorage.getItem("agencyStepThree")) ?? null,
    profilePicSignedUrl:
      JSON.parse(localStorage.getItem("profilePicSignedUrl")) ?? null,
  },
  reducers: {
    setArtistStepOne: (state, action) => {
      state.artistStepOne = action.payload;
      localStorage.setItem("stepOne", JSON.stringify(action.payload));
    },
    setArtistStepTwo: (state, action) => {
      state.artistStepTwo = action.payload;
      localStorage.setItem("stepTwo", JSON.stringify(action.payload));
    },
    setArtistStepThree: (state, action) => {
      state.artistStepThree = action.payload;
      localStorage.setItem("stepThree", JSON.stringify(action.payload));
    },
    setrecruiterStepOne: (state, action) => {
      state.recruiterStepOne = action.payload;
      localStorage.setItem("recruiterStepOne", JSON.stringify(action.payload));
    },
    setArtistStepFour: (state, action) => {
      state.artistStepFour = action.payload;
      localStorage.setItem("stepFour", JSON.stringify(action.payload));
    },
    setArtistStepFive: (state, action) => {
      state.artistStepFive = action.payload;
      localStorage.setItem("stepFive", JSON.stringify(action.payload));
    },
    setAgencyLogo: (state, action) => {
      state.agencyLogo = action.payload;
      localStorage.setItem("agencyLogo", JSON.stringify(action.payload));
    },

    setAgencyLogoSignedUrl: (state, action) => {
      state.agencyLogoSignedUrl = action.payload;
      localStorage.setItem(
        "agencyLogoSignedUrl",
        JSON.stringify(action.payload),
      );
    },
    setAgencyStepTwo:(state,action)=>{
      state.agencyStepTwo=action.payload;
      localStorage.setItem("agencyStepTwo",JSON.stringify(action.payload));
    },
    setAgencyStepThree:(state,action)=>{
      state.agencyStepThree=action.payload;
      localStorage.setItem("agencyStepThree",JSON.stringify(action.payload));
    },
    setrecruiterStepTwo: (state, action) => {
      state.recruiterStepTwo = action.payload;
      localStorage.setItem("recruiterStepTwo", JSON.stringify(action.payload));
    },
    setAgencyStepOne: (state, action) => {
      state.agencyStepOne = action.payload;
      localStorage.setItem("agencyStepOne", JSON.stringify(action.payload));
    },

    setProfilePicDetails: (state, action) => {
      state.profilePicSignedUrl = action.payload;
      localStorage.setItem(
        "profilePicSignedUrl",
        JSON.stringify(action.payload),
      );
    },
    setProfilePic: (state, action) => {
      state.profilePic = action.payload;
      localStorage.setItem("profilePic", JSON.stringify(action.payload));
    },
    clearStepsData: (state) => {
      localStorage.removeItem("stepOne");
      localStorage.removeItem("stepTwo");
      localStorage.removeItem("stepThree");
      localStorage.removeItem("stepFour");
      localStorage.removeItem("stepFive");
      localStorage.removeItem("profilePicSignedUrl");
      localStorage.removeItem("profilePic");
      localStorage.removeItem("recruiterStepOne");
      localStorage.removeItem("recruiterStepTwo");
      localStorage.removeItem("agencyStepOne");
      localStorage.removeItem("agencyLogo");
      localStorage.removeItem("agencyLogoSignedUrl");
      localStorage.removeItem("agencyStepTwo");
      localStorage.removeItem("agencyStepThree");

      state.agencyLogo = null;
      state.agencyLogoSignedUrl = null;
      state.artistStepOne = null;
      state.artistStepTwo = null;
      state.artistStepThree = null;
      state.artistStepFour = null;
      state.artistStepFive = null;
      state.profilePic = null;
      state.profilePicSignedUrl = null;
      state.recruiterStepOne = null;
      state.recruiterStepTwo = null;
      state.agencyStepOne = null;
      state.agencyStepTwo=null;
      state.agencyStepThree=null;
    },
  },
});
export const {
  setArtistStepOne,
  setArtistStepTwo,
  setArtistStepThree,
  setArtistStepFour,
  setArtistStepFive,
  setProfilePicDetails,
  setProfilePic,
  setrecruiterStepOne,
  setrecruiterStepTwo,
  setAgencyStepOne,
  setAgencyLogo,
  setAgencyLogoSignedUrl,
  setAgencyStepTwo,
  setAgencyStepThree,
  clearStepsData,
} = ArtistScreenSlice.actions;

export default ArtistScreenSlice.reducer;
